// Single switch for every consent gate (scripts, Datadog, location events).
// true: they load without waiting for an accept. false: consent is enforced.
export const SKIP_COOKIE_CONSENT = true
